// Countries list - comprehensive global coverage
export const countries = [
  "United States", "United Kingdom", "Canada", "Australia", "Germany", "France", 
  "Nigeria", "South Africa", "Ghana", "Kenya", "India", "China", "Japan", 
  "Brazil", "Mexico", "Spain", "Italy", "Netherlands", "Sweden", "Norway",
  "Denmark", "Finland", "Ireland", "New Zealand", "Singapore", "Hong Kong",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Israel", "Egypt",
  "Poland", "Switzerland", "Austria", "Belgium", "Portugal", "Greece",
  "Czech Republic", "Romania", "Hungary", "Ukraine", "Russia", "Turkey",
  "Indonesia", "Malaysia", "Philippines", "Thailand", "Vietnam", "Pakistan",
  "Bangladesh", "Sri Lanka", "Argentina", "Chile", "Colombia", "Peru",
  "South Korea", "Taiwan", "Morocco", "Tunisia", "Algeria", "Ethiopia",
  "Tanzania", "Uganda", "Rwanda", "Senegal", "Ivory Coast", "Cameroon",
  "Luxembourg", "Malta", "Cyprus", "Iceland", "Estonia", "Latvia", "Lithuania",
  "Slovenia", "Slovakia", "Croatia", "Serbia", "Bulgaria", "North Macedonia",
  "Albania", "Bosnia and Herzegovina", "Montenegro", "Moldova", "Belarus",
  "Kazakhstan", "Uzbekistan", "Azerbaijan", "Georgia", "Armenia",
  "Kuwait", "Bahrain", "Oman", "Jordan", "Lebanon", "Iraq", "Iran",
  "Afghanistan", "Nepal", "Myanmar", "Cambodia", "Laos", "Mongolia",
  "Brunei", "Maldives", "Fiji", "Papua New Guinea",
  "Jamaica", "Trinidad and Tobago", "Barbados", "Bahamas", "Haiti", "Dominican Republic",
  "Cuba", "Puerto Rico", "Costa Rica", "Panama", "Guatemala", "Honduras",
  "El Salvador", "Nicaragua", "Ecuador", "Bolivia", "Paraguay", "Uruguay", "Venezuela"
].sort();

// States/Regions by country
export const statesByCountry = {
  "United States": [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", 
    "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", 
    "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", 
    "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", 
    "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", 
    "New Hampshire", "New Jersey", "New Mexico", "New York", 
    "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", 
    "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", 
    "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", 
    "West Virginia", "Wisconsin", "Wyoming", "District of Columbia"
  ],
  "United Kingdom": [
    "England", "Scotland", "Wales", "Northern Ireland"
  ],
  "Canada": [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick", 
    "Newfoundland and Labrador", "Nova Scotia", "Ontario", 
    "Prince Edward Island", "Quebec", "Saskatchewan", "Northwest Territories", "Nunavut", "Yukon"
  ],
  "Australia": [
    "New South Wales", "Victoria", "Queensland", "Western Australia", 
    "South Australia", "Tasmania", "Northern Territory", "Australian Capital Territory"
  ],
  "Nigeria": [
    "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue",
    "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu",
    "FCT Abuja", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina",
    "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo",
    "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"
  ],
  "Germany": [
    "Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen",
    "Hamburg", "Hesse", "Lower Saxony", "Mecklenburg-Vorpommern",
    "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland",
    "Saxony", "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"
  ],
  "India": [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
    "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
    "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
    "West Bengal", "Delhi", "Chandigarh", "Puducherry"
  ],
  "France": [
    "Île-de-France", "Provence-Alpes-Côte d'Azur", "Auvergne-Rhône-Alpes",
    "Occitanie", "Nouvelle-Aquitaine", "Hauts-de-France", "Grand Est",
    "Bretagne", "Normandy", "Pays de la Loire", "Bourgogne-Franche-Comté",
    "Centre-Val de Loire", "Corsica"
  ],
  "Spain": [
    "Andalusia", "Catalonia", "Madrid", "Valencia", "Galicia", "Basque Country",
    "Castile and León", "Castile-La Mancha", "Canary Islands", "Murcia",
    "Aragon", "Balearic Islands", "Extremadura", "Asturias", "Navarre",
    "Cantabria", "La Rioja"
  ],
  "Italy": [
    "Lombardy", "Lazio", "Campania", "Veneto", "Sicily", "Emilia-Romagna",
    "Piedmont", "Tuscany", "Puglia", "Calabria", "Sardinia", "Liguria",
    "Marche", "Abruzzo", "Friuli-Venezia Giulia", "Trentino-Alto Adige",
    "Umbria", "Basilicata", "Molise", "Valle d'Aosta"
  ],
  "Brazil": [
    "São Paulo", "Rio de Janeiro", "Minas Gerais", "Bahia", "Paraná",
    "Rio Grande do Sul", "Pernambuco", "Ceará", "Pará", "Santa Catarina",
    "Goiás", "Maranhão", "Amazonas", "Espírito Santo", "Paraíba",
    "Mato Grosso", "Mato Grosso do Sul", "Distrito Federal"
  ],
  "Mexico": [
    "Mexico City", "Jalisco", "Nuevo León", "Estado de México", "Veracruz",
    "Guanajuato", "Puebla", "Chihuahua", "Tamaulipas", "Baja California",
    "Sonora", "Coahuila", "Sinaloa", "Michoacán", "Oaxaca", "Querétaro",
    "Yucatán", "Quintana Roo", "Aguascalientes", "Morelos"
  ],
  "South Africa": [
    "Gauteng", "KwaZulu-Natal", "Western Cape", "Eastern Cape", "Limpopo",
    "Mpumalanga", "North West", "Free State", "Northern Cape"
  ],
  "China": [
    "Beijing", "Shanghai", "Guangdong", "Jiangsu", "Zhejiang", "Shandong",
    "Sichuan", "Henan", "Hubei", "Fujian", "Hunan", "Anhui", "Hebei",
    "Liaoning", "Shaanxi", "Chongqing", "Tianjin", "Yunnan", "Guangxi",
    "Jiangxi", "Shanxi", "Guizhou", "Heilongjiang", "Jilin", "Gansu",
    "Inner Mongolia", "Xinjiang", "Hainan", "Ningxia", "Tibet", "Qinghai"
  ],
  "Japan": [
    "Tokyo", "Osaka", "Kanagawa", "Aichi", "Saitama", "Chiba", "Hyogo",
    "Hokkaido", "Fukuoka", "Shizuoka", "Ibaraki", "Hiroshima", "Kyoto",
    "Niigata", "Miyagi", "Nagano", "Gifu", "Gunma", "Tochigi", "Okayama",
    "Mie", "Kumamoto", "Kagoshima", "Okinawa", "Nara", "Shiga"
  ],
  "South Korea": [
    "Seoul", "Busan", "Incheon", "Daegu", "Daejeon", "Gwangju", "Ulsan",
    "Gyeonggi", "Gangwon", "North Chungcheong", "South Chungcheong",
    "North Gyeongsang", "South Gyeongsang", "North Jeolla", "South Jeolla", "Jeju"
  ],
  "Singapore": ["Central Region", "East Region", "North Region", "North-East Region", "West Region"],
  "United Arab Emirates": ["Abu Dhabi", "Dubai", "Sharjah", "Ajman", "Umm Al Quwain", "Ras Al Khaimah", "Fujairah"],
  "Netherlands": ["North Holland", "South Holland", "Utrecht", "North Brabant", "Gelderland", "Limburg", "Overijssel", "Flevoland", "Groningen", "Friesland", "Drenthe", "Zeeland"],
  "Switzerland": ["Zürich", "Geneva", "Bern", "Basel-Stadt", "Vaud", "Ticino", "Lucerne", "St. Gallen", "Aargau", "Valais"],
  "Ireland": ["Dublin", "Cork", "Galway", "Limerick", "Waterford", "Kilkenny", "Kerry", "Clare", "Mayo", "Wicklow"],
  "Poland": ["Masovian", "Lesser Poland", "Silesian", "Greater Poland", "Lower Silesian", "Pomeranian", "Łódź", "West Pomeranian"],
  "Sweden": ["Stockholm", "Västra Götaland", "Skåne", "Östergötland", "Uppsala", "Jönköping", "Halland", "Örebro", "Dalarna", "Gävleborg"],
  "Norway": ["Oslo", "Viken", "Rogaland", "Trøndelag", "Vestland", "Innlandet", "Agder", "Vestfold og Telemark", "Nordland", "Møre og Romsdal"],
  "Denmark": ["Capital Region", "Central Denmark", "North Denmark", "Region Zealand", "Region of Southern Denmark"],
  "Finland": ["Uusimaa", "Pirkanmaa", "Varsinais-Suomi", "North Ostrobothnia", "Central Finland", "Päijät-Häme", "Satakunta", "South Ostrobothnia"],
  "Austria": ["Vienna", "Lower Austria", "Upper Austria", "Styria", "Tyrol", "Salzburg", "Carinthia", "Vorarlberg", "Burgenland"],
  "Belgium": ["Brussels", "Flanders", "Wallonia", "Antwerp", "East Flanders", "West Flanders", "Limburg", "Flemish Brabant"],
  "Portugal": ["Lisbon", "Porto", "Braga", "Setúbal", "Aveiro", "Faro", "Leiria", "Coimbra", "Viseu", "Santarém"],
  "Greece": ["Attica", "Central Macedonia", "Thessaly", "Western Greece", "Crete", "Central Greece", "Peloponnese", "Eastern Macedonia and Thrace"],
  "Turkey": ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya", "Adana", "Konya", "Gaziantep", "Mersin", "Kayseri", "Eskişehir", "Trabzon"],
  "Russia": ["Moscow", "Saint Petersburg", "Novosibirsk", "Sverdlovsk", "Tatarstan", "Krasnodar", "Nizhny Novgorod", "Samara", "Chelyabinsk", "Rostov"],
  "Indonesia": ["Jakarta", "West Java", "East Java", "Central Java", "Banten", "North Sumatra", "South Sulawesi", "Bali", "East Kalimantan", "Yogyakarta"],
  "Malaysia": ["Selangor", "Kuala Lumpur", "Johor", "Penang", "Perak", "Sabah", "Sarawak", "Kelantan", "Pahang", "Melaka", "Negeri Sembilan", "Kedah"],
  "Philippines": ["Metro Manila", "Cebu", "Davao", "Calabarzon", "Central Luzon", "Central Visayas", "Western Visayas", "Northern Mindanao", "Ilocos Region"],
  "Thailand": ["Bangkok", "Chiang Mai", "Phuket", "Nonthaburi", "Chonburi", "Nakhon Ratchasima", "Khon Kaen", "Samut Prakan", "Udon Thani"],
  "Vietnam": ["Ho Chi Minh City", "Hanoi", "Da Nang", "Hai Phong", "Can Tho", "Binh Duong", "Dong Nai", "Khanh Hoa", "Quang Ninh"],
  "Pakistan": ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan", "Islamabad Capital Territory", "Gilgit-Baltistan", "Azad Kashmir"],
  "Bangladesh": ["Dhaka", "Chittagong", "Rajshahi", "Khulna", "Sylhet", "Rangpur", "Barisal", "Mymensingh"],
  "Argentina": ["Buenos Aires", "Córdoba", "Santa Fe", "Mendoza", "Tucumán", "Entre Ríos", "Salta", "Misiones", "Chaco", "Corrientes"],
  "Chile": ["Santiago Metropolitan", "Valparaíso", "Biobío", "Maule", "La Araucanía", "O'Higgins", "Los Lagos", "Coquimbo", "Antofagasta"],
  "Colombia": ["Bogotá", "Antioquia", "Valle del Cauca", "Atlántico", "Cundinamarca", "Santander", "Bolívar", "Tolima", "Norte de Santander"],
  "Peru": ["Lima", "Arequipa", "La Libertad", "Piura", "Lambayeque", "Cusco", "Junín", "Callao", "Áncash", "Ica"],
  "Egypt": ["Cairo", "Alexandria", "Giza", "Dakahlia", "Qalyubia", "Sharqia", "Gharbia", "Beheira", "Fayoum", "Minya"],
  "Saudi Arabia": ["Riyadh", "Makkah", "Madinah", "Eastern Province", "Asir", "Qassim", "Tabuk", "Hail", "Jazan", "Najran"],
  "Kenya": ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret", "Nyeri", "Machakos", "Meru", "Kakamega", "Thika"],
  "Ghana": ["Greater Accra", "Ashanti", "Western", "Eastern", "Central", "Northern", "Volta", "Upper East", "Upper West", "Brong-Ahafo"],
  "New Zealand": ["Auckland", "Wellington", "Canterbury", "Waikato", "Bay of Plenty", "Otago", "Manawatu-Wanganui", "Hawke's Bay", "Taranaki"]
};

// Nationalities
export const nationalities = [
  "Afghan", "Albanian", "Algerian", "American", "Andorran", "Angolan", 
  "Argentine", "Armenian", "Australian", "Austrian", "Azerbaijani",
  "Bangladeshi", "Belgian", "Bolivian", "Bosnian", "Brazilian", "British",
  "Bulgarian", "Cambodian", "Cameroonian", "Canadian", "Chilean", "Chinese",
  "Colombian", "Congolese", "Costa Rican", "Croatian", "Cuban", "Czech",
  "Danish", "Dominican", "Dutch", "Ecuadorian", "Egyptian", "Emirati",
  "English", "Estonian", "Ethiopian", "Filipino", "Finnish", "French",
  "German", "Ghanaian", "Greek", "Guatemalan", "Haitian", "Honduran",
  "Hungarian", "Icelandic", "Indian", "Indonesian", "Iranian", "Iraqi",
  "Irish", "Israeli", "Italian", "Jamaican", "Japanese", "Jordanian",
  "Kazakh", "Kenyan", "Korean", "Kuwaiti", "Latvian", "Lebanese",
  "Libyan", "Lithuanian", "Malaysian", "Mexican", "Moroccan", "Nepalese",
  "New Zealander", "Nigerian", "Norwegian", "Pakistani", "Panamanian",
  "Paraguayan", "Peruvian", "Polish", "Portuguese", "Qatari", "Romanian",
  "Russian", "Saudi", "Scottish", "Senegalese", "Serbian", "Singaporean",
  "Slovak", "Slovenian", "South African", "Spanish", "Sri Lankan", "Sudanese",
  "Swedish", "Swiss", "Syrian", "Taiwanese", "Tanzanian", "Thai", "Tunisian",
  "Turkish", "Ugandan", "Ukrainian", "Uruguayan", "Venezuelan", "Vietnamese",
  "Welsh", "Yemeni", "Zambian", "Zimbabwean"
].sort();

// Industries
export const industries = [
  "Accounting & Finance",
  "Advertising & Marketing",
  "Aerospace & Defense",
  "Agriculture & Farming",
  "Architecture & Planning",
  "Arts & Entertainment",
  "Automotive",
  "Banking & Financial Services",
  "Biotechnology",
  "Business Consulting",
  "Chemicals",
  "Civil Engineering",
  "Computer Hardware",
  "Computer Software",
  "Construction",
  "Consumer Goods",
  "Customer Service",
  "E-commerce",
  "Education & Training",
  "Electronics",
  "Energy & Utilities",
  "Engineering",
  "Environmental Services",
  "Event Management",
  "Fashion & Apparel",
  "Film & Television",
  "Food & Beverage",
  "Government & Public Sector",
  "Healthcare & Medical",
  "Hospitality & Tourism",
  "Human Resources",
  "Information Technology",
  "Insurance",
  "Internet & Digital Media",
  "Investment Banking",
  "Legal Services",
  "Logistics & Supply Chain",
  "Management Consulting",
  "Manufacturing",
  "Maritime & Shipping",
  "Media & Communications",
  "Mining & Metals",
  "Music & Audio",
  "Non-Profit & NGO",
  "Oil & Gas",
  "Pharmaceuticals",
  "Photography",
  "Public Relations",
  "Publishing",
  "Real Estate",
  "Recruitment & Staffing",
  "Research & Development",
  "Retail",
  "Sales",
  "Security Services",
  "Social Services",
  "Sports & Fitness",
  "Telecommunications",
  "Textiles",
  "Transportation",
  "Travel & Leisure",
  "Venture Capital & Private Equity",
  "Veterinary",
  "Warehousing",
  "Wholesale"
];

// Months for date of birth
export const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

// Generate years (for date of birth - 18 to 80 years old)
export const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 18; i >= currentYear - 80; i--) {
    years.push(i);
  }
  return years;
};

// Generate days
export const generateDays = () => {
  const days = [];
  for (let i = 1; i <= 31; i++) {
    days.push(i);
  }
  return days;
};

// Employment Types
export const employmentTypes = [
  { value: "full-time", label: "Full-Time" },
  { value: "part-time", label: "Part-Time" },
  { value: "contract", label: "Contract" },
  { value: "temporary", label: "Temporary" },
  { value: "freelance", label: "Freelance" },
  { value: "internship", label: "Internship" },
  { value: "volunteer", label: "Volunteer" },
  { value: "apprenticeship", label: "Apprenticeship" }
];

// Cities by Country and State
export const citiesByState = {
  "United States": {
    "California": ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento", "Oakland", "Fresno", "Long Beach", "Irvine", "Palo Alto", "Santa Monica", "Pasadena", "Berkeley", "Anaheim", "Santa Clara"],
    "New York": ["New York City", "Buffalo", "Rochester", "Albany", "Syracuse", "Yonkers", "New Rochelle", "White Plains", "Ithaca"],
    "Texas": ["Houston", "Dallas", "Austin", "San Antonio", "Fort Worth", "El Paso", "Arlington", "Plano", "Irving", "Frisco", "McKinney"],
    "Florida": ["Miami", "Orlando", "Tampa", "Jacksonville", "Fort Lauderdale", "St. Petersburg", "Hialeah", "Boca Raton", "West Palm Beach"],
    "Illinois": ["Chicago", "Aurora", "Naperville", "Joliet", "Rockford", "Springfield", "Evanston", "Schaumburg"],
    "Pennsylvania": ["Philadelphia", "Pittsburgh", "Allentown", "Erie", "Reading", "Scranton", "Bethlehem"],
    "Georgia": ["Atlanta", "Augusta", "Columbus", "Savannah", "Athens", "Sandy Springs", "Roswell", "Alpharetta"],
    "Washington": ["Seattle", "Spokane", "Tacoma", "Vancouver", "Bellevue", "Redmond", "Kirkland", "Everett"],
    "Massachusetts": ["Boston", "Cambridge", "Worcester", "Springfield", "Lowell", "Quincy", "Somerville"],
    "Colorado": ["Denver", "Colorado Springs", "Aurora", "Fort Collins", "Boulder", "Lakewood", "Thornton"],
    "North Carolina": ["Charlotte", "Raleigh", "Durham", "Greensboro", "Winston-Salem", "Cary", "Chapel Hill"],
    "Arizona": ["Phoenix", "Tucson", "Mesa", "Scottsdale", "Chandler", "Tempe", "Gilbert"],
    "Michigan": ["Detroit", "Grand Rapids", "Ann Arbor", "Lansing", "Dearborn", "Troy", "Warren"],
    "Ohio": ["Columbus", "Cleveland", "Cincinnati", "Toledo", "Akron", "Dayton"],
    "New Jersey": ["Newark", "Jersey City", "Paterson", "Trenton", "Princeton", "Hoboken"],
    "Virginia": ["Virginia Beach", "Norfolk", "Richmond", "Arlington", "Alexandria", "Reston", "Tysons"],
    "Maryland": ["Baltimore", "Bethesda", "Rockville", "Silver Spring", "Columbia", "Annapolis"],
    "Tennessee": ["Nashville", "Memphis", "Knoxville", "Chattanooga", "Franklin"],
    "Minnesota": ["Minneapolis", "St. Paul", "Rochester", "Bloomington", "Duluth"],
    "Missouri": ["Kansas City", "St. Louis", "Springfield", "Columbia"],
    "District of Columbia": ["Washington D.C."]
  },
  "United Kingdom": {
    "England": ["London", "Manchester", "Birmingham", "Liverpool", "Leeds", "Bristol", "Newcastle", "Sheffield", "Nottingham", "Cambridge", "Oxford", "Brighton", "Southampton", "Leicester", "Reading", "Milton Keynes"],
    "Scotland": ["Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness", "Stirling"],
    "Wales": ["Cardiff", "Swansea", "Newport", "Wrexham", "Bangor"],
    "Northern Ireland": ["Belfast", "Derry", "Lisburn", "Newry", "Bangor"]
  },
  "Nigeria": {
    "Lagos": ["Lagos Island", "Ikeja", "Victoria Island", "Lekki", "Ikoyi", "Surulere", "Yaba", "Ajah", "Gbagada"],
    "FCT Abuja": ["Abuja", "Garki", "Maitama", "Asokoro", "Wuse", "Gwarinpa", "Jabi", "Kubwa"],
    "Rivers": ["Port Harcourt", "Obio-Akpor", "Bonny", "Eleme"],
    "Oyo": ["Ibadan", "Ogbomoso", "Oyo", "Iseyin"],
    "Kano": ["Kano", "Fagge", "Nassarawa", "Tarauni"],
    "Kaduna": ["Kaduna", "Zaria", "Kafanchan"],
    "Ogun": ["Abeokuta", "Ijebu Ode", "Sagamu", "Ota"],
    "Delta": ["Asaba", "Warri", "Sapele", "Ughelli"],
    "Enugu": ["Enugu", "Nsukka", "Agbani"]
  },
  "Canada": {
    "Ontario": ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor", "Waterloo"],
    "British Columbia": ["Vancouver", "Victoria", "Burnaby", "Surrey", "Richmond", "Kelowna", "Abbotsford"],
    "Quebec": ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke"],
    "Alberta": ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "Medicine Hat", "Fort McMurray"],
    "Manitoba": ["Winnipeg", "Brandon", "Steinbach"],
    "Saskatchewan": ["Saskatoon", "Regina", "Prince Albert"],
    "Nova Scotia": ["Halifax", "Dartmouth", "Sydney"]
  },
  "Australia": {
    "New South Wales": ["Sydney", "Newcastle", "Wollongong", "Central Coast", "Parramatta", "Chatswood"],
    "Victoria": ["Melbourne", "Geelong", "Ballarat", "Bendigo", "Docklands", "South Yarra"],
    "Queensland": ["Brisbane", "Gold Coast", "Sunshine Coast", "Townsville", "Cairns", "Toowoomba"],
    "Western Australia": ["Perth", "Fremantle", "Mandurah", "Bunbury"],
    "South Australia": ["Adelaide", "Mount Gambier", "Whyalla"],
    "Australian Capital Territory": ["Canberra"]
  },
  "Germany": {
    "Berlin": ["Berlin"],
    "Bavaria": ["Munich", "Nuremberg", "Augsburg", "Regensburg", "Würzburg"],
    "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen", "Duisburg", "Bonn", "Münster"],
    "Hesse": ["Frankfurt", "Wiesbaden", "Kassel", "Darmstadt", "Offenbach"],
    "Hamburg": ["Hamburg"],
    "Baden-Württemberg": ["Stuttgart", "Mannheim", "Karlsruhe", "Freiburg", "Heidelberg"],
    "Lower Saxony": ["Hanover", "Braunschweig", "Oldenburg", "Osnabrück"],
    "Saxony": ["Leipzig", "Dresden", "Chemnitz"]
  },
  "India": {
    "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane", "Navi Mumbai", "Aurangabad"],
    "Karnataka": ["Bangalore", "Mysore", "Mangalore", "Hubli", "Belgaum"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem", "Tiruchirappalli", "Vellore"],
    "Delhi": ["New Delhi", "Delhi", "Noida", "Gurgaon", "Faridabad", "Ghaziabad"],
    "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Secunderabad"],
    "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
    "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
    "Punjab": ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar"],
    "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Allahabad"]
  },
  "France": {
    "Île-de-France": ["Paris", "Versailles", "Boulogne-Billancourt", "Saint-Denis", "Nanterre", "La Défense"],
    "Provence-Alpes-Côte d'Azur": ["Marseille", "Nice", "Toulon", "Cannes", "Aix-en-Provence"],
    "Auvergne-Rhône-Alpes": ["Lyon", "Grenoble", "Saint-Étienne", "Villeurbanne"],
    "Occitanie": ["Toulouse", "Montpellier", "Nîmes", "Perpignan"],
    "Nouvelle-Aquitaine": ["Bordeaux", "Limoges", "Poitiers", "La Rochelle"],
    "Hauts-de-France": ["Lille", "Amiens", "Roubaix", "Tourcoing"],
    "Grand Est": ["Strasbourg", "Reims", "Metz", "Mulhouse"],
    "Bretagne": ["Rennes", "Brest", "Quimper", "Saint-Malo"],
    "Normandy": ["Rouen", "Le Havre", "Caen"]
  },
  "Spain": {
    "Madrid": ["Madrid", "Alcalá de Henares", "Getafe", "Leganés", "Alcorcón"],
    "Catalonia": ["Barcelona", "Tarragona", "Girona", "Lleida", "Sabadell"],
    "Andalusia": ["Seville", "Málaga", "Granada", "Córdoba", "Cádiz"],
    "Valencia": ["Valencia", "Alicante", "Elche", "Castellón"],
    "Basque Country": ["Bilbao", "San Sebastián", "Vitoria-Gasteiz"],
    "Galicia": ["A Coruña", "Vigo", "Santiago de Compostela", "Ourense"]
  },
  "Italy": {
    "Lombardy": ["Milan", "Bergamo", "Brescia", "Monza", "Como"],
    "Lazio": ["Rome", "Latina", "Frosinone"],
    "Campania": ["Naples", "Salerno", "Caserta"],
    "Veneto": ["Venice", "Verona", "Padua", "Vicenza", "Treviso"],
    "Piedmont": ["Turin", "Novara", "Alessandria"],
    "Emilia-Romagna": ["Bologna", "Modena", "Parma", "Reggio Emilia", "Rimini"],
    "Tuscany": ["Florence", "Pisa", "Livorno", "Siena", "Lucca"]
  },
  "Japan": {
    "Tokyo": ["Tokyo", "Shibuya", "Shinjuku", "Minato", "Chiyoda", "Shinagawa"],
    "Osaka": ["Osaka", "Sakai", "Higashiosaka"],
    "Kanagawa": ["Yokohama", "Kawasaki", "Sagamihara"],
    "Aichi": ["Nagoya", "Toyota", "Okazaki"],
    "Fukuoka": ["Fukuoka", "Kitakyushu"],
    "Kyoto": ["Kyoto", "Uji"],
    "Hyogo": ["Kobe", "Himeji", "Nishinomiya"],
    "Hokkaido": ["Sapporo", "Asahikawa", "Hakodate"]
  },
  "South Korea": {
    "Seoul": ["Seoul", "Gangnam", "Jongno", "Mapo", "Yeongdeungpo"],
    "Busan": ["Busan", "Haeundae"],
    "Incheon": ["Incheon", "Songdo"],
    "Gyeonggi": ["Suwon", "Seongnam", "Goyang", "Yongin", "Bucheon"]
  },
  "Singapore": {
    "Central Region": ["Downtown Core", "Orchard", "Marina Bay", "Tanjong Pagar"],
    "East Region": ["Changi", "Tampines", "Bedok"],
    "West Region": ["Jurong", "Clementi", "Bukit Batok"],
    "North Region": ["Woodlands", "Yishun", "Sembawang"]
  },
  "United Arab Emirates": {
    "Dubai": ["Dubai", "Downtown Dubai", "Dubai Marina", "Business Bay", "DIFC", "JLT"],
    "Abu Dhabi": ["Abu Dhabi", "Al Reem Island", "Yas Island", "Saadiyat Island"],
    "Sharjah": ["Sharjah", "Al Majaz", "Al Nahda"]
  },
  "Netherlands": {
    "North Holland": ["Amsterdam", "Haarlem", "Zaandam", "Hilversum"],
    "South Holland": ["Rotterdam", "The Hague", "Leiden", "Delft", "Dordrecht"],
    "Utrecht": ["Utrecht", "Amersfoort", "Nieuwegein"],
    "North Brabant": ["Eindhoven", "Tilburg", "Breda", "'s-Hertogenbosch"]
  },
  "Switzerland": {
    "Zürich": ["Zürich", "Winterthur", "Uster"],
    "Geneva": ["Geneva", "Carouge"],
    "Bern": ["Bern", "Biel/Bienne", "Thun"],
    "Basel-Stadt": ["Basel"],
    "Vaud": ["Lausanne", "Montreux", "Nyon"]
  },
  "China": {
    "Beijing": ["Beijing", "Chaoyang", "Haidian", "Dongcheng"],
    "Shanghai": ["Shanghai", "Pudong", "Jing'an", "Huangpu"],
    "Guangdong": ["Guangzhou", "Shenzhen", "Dongguan", "Foshan", "Zhuhai"],
    "Jiangsu": ["Nanjing", "Suzhou", "Wuxi", "Changzhou"],
    "Zhejiang": ["Hangzhou", "Ningbo", "Wenzhou", "Jiaxing"],
    "Sichuan": ["Chengdu", "Mianyang", "Leshan"]
  },
  "Brazil": {
    "São Paulo": ["São Paulo", "Campinas", "Santos", "Guarulhos", "São Bernardo do Campo"],
    "Rio de Janeiro": ["Rio de Janeiro", "Niterói", "Nova Iguaçu"],
    "Minas Gerais": ["Belo Horizonte", "Uberlândia", "Juiz de Fora"],
    "Paraná": ["Curitiba", "Londrina", "Maringá"],
    "Rio Grande do Sul": ["Porto Alegre", "Caxias do Sul", "Pelotas"],
    "Distrito Federal": ["Brasília"]
  },
  "Mexico": {
    "Mexico City": ["Mexico City", "Coyoacán", "Polanco", "Santa Fe", "Condesa"],
    "Jalisco": ["Guadalajara", "Zapopan", "Tlaquepaque"],
    "Nuevo León": ["Monterrey", "San Pedro Garza García", "San Nicolás"],
    "Querétaro": ["Querétaro", "San Juan del Río"],
    "Quintana Roo": ["Cancún", "Playa del Carmen", "Tulum"]
  },
  "South Africa": {
    "Gauteng": ["Johannesburg", "Pretoria", "Sandton", "Midrand", "Centurion"],
    "Western Cape": ["Cape Town", "Stellenbosch", "Paarl"],
    "KwaZulu-Natal": ["Durban", "Pietermaritzburg", "Umhlanga"]
  }
};
